import React from 'react';
import { TrendingUp, Award, MapPin } from 'lucide-react';
export function ScopertiScreen() {
  const categories = [{
    id: 1,
    title: 'Vini in tendenza',
    icon: TrendingUp,
    color: '#6C083B',
    count: 24
  }, {
    id: 2,
    title: 'Premiati 2024',
    icon: Award,
    color: '#6C083B',
    count: 18
  }, {
    id: 3,
    title: 'Cantine da visitare',
    icon: MapPin,
    color: '#6C083B',
    count: 12
  }];
  const featured = [{
    id: 1,
    title: 'I migliori Barolo sotto €100',
    description: 'Selezione curata dai nostri sommelier',
    image: '🍷',
    tag: 'Guida'
  }, {
    id: 2,
    title: "Abbinamenti perfetti per l'estate",
    description: 'Vini freschi per le giornate calde',
    image: '☀️',
    tag: 'Stagionale'
  }, {
    id: 3,
    title: 'Cantine emergenti in Toscana',
    description: "Scopri i nuovi produttori da tenere d'occhio",
    image: '🏛️',
    tag: 'Territorio'
  }];
  return <div className="h-full overflow-y-auto bg-white" data-id="element-297">
      <div className="px-5 py-6" data-id="element-298">
        <p className="text-sm text-gray-500 mb-8" data-id="element-299">
          Esplora il mondo del vino italiano
        </p>

        {/* Categories - Structured Grid */}
        <div className="grid grid-cols-1 gap-4 mb-8" data-id="element-300">
          {categories.map(category => {
          const Icon = category.icon;
          return <button key={category.id} className="w-full flex items-center gap-4 p-4 text-left transition-all hover:shadow-lg" style={{
            backgroundColor: '#FFFFFF',
            border: '2px solid #6C083B',
            borderRadius: '16px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
          }} data-id="element-301">
                {/* Icon Circle */}
                <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: '#F9FAFB',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }} data-id="element-302">
                  <Icon size={24} style={{
                color: category.color
              }} strokeWidth={1.5} data-id="element-303" />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-304">
                  <h3 className="text-sm font-semibold text-gray-900 mb-1" data-id="element-305">
                    {category.title}
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-306">
                    {category.count} contenuti
                  </p>
                </div>

                {/* Count Badge */}
                <div style={{
              backgroundColor: '#6C083B',
              color: '#FFFFFF',
              fontSize: '11px',
              fontWeight: '600',
              padding: '4px 10px',
              borderRadius: '12px',
              flexShrink: 0
            }} data-id="element-307">
                  {category.count}
                </div>
              </button>;
        })}
        </div>

        {/* Featured Content */}
        <div className="mb-6" data-id="element-308">
          <h3 className="text-sm font-medium text-gray-900 mb-4" data-id="element-309">
            In evidenza
          </h3>
          <div className="space-y-4" data-id="element-310">
            {featured.map(item => <div key={item.id} className="py-4 border-b border-gray-100 last:border-0" data-id="element-311">
                <div className="flex items-start gap-3" data-id="element-312">
                  <div className="text-2xl" data-id="element-313">{item.image}</div>
                  <div className="flex-1 min-w-0" data-id="element-314">
                    <span className="inline-block text-xs text-gray-500 mb-2" data-id="element-315">
                      {item.tag}
                    </span>
                    <h4 className="text-sm text-gray-900 mb-1" data-id="element-316">{item.title}</h4>
                    <p className="text-xs text-gray-500 mb-3" data-id="element-317">
                      {item.description}
                    </p>
                    <button className="text-xs text-gray-500 hover:text-gray-900 transition-colors" data-id="element-318">
                      Leggi di più →
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}